/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetGoalsRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetGoalsResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getGoals = (request: GetGoalsRequest, options?: CashRequestOptions) => post<GetGoalsRequest, GetGoalsResponse>("/2.0/cash/get-goals", request, {...options, rejectOnError: true })